import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
//import styles from '../Questionnaire/NewPatientQuestionnaire.module.css'
import style from './FinishingRetainerSummary.module.css';
import Zoom from 'react-medium-image-zoom';
import { withLang } from '../../../util/lang';
import { Box, Typography } from '@material-ui/core';
import StarRateIcon from '@material-ui/icons/StarRate';
import { getWebAbsPath } from '../../../util/path';
import { fromJS, removeIn } from 'immutable';
// const labelIntrerpret = {
//   primary: this.get('questionnaire.primary'),
//   secondary: "Secondary",
//   none: "None",
//   clinicalSimulation: "Refer to Clinical Simulation",
//   improve1mm: 'Improve 1mm',
//   improve2mm: 'Improve 2mm',
//   improve3mm: 'Improve 3mm',
//   improve4mm: 'Improve 4mm',
//   improve5mm: 'Improve 5mm',
//   maintain: "Maintain",
//   improve: "Improve",
//   improveUpper: 'Improve Upper to match Facial Midline',
//   lowerLower: 'Improve Lower midline to match Upper midline',
//   upperLowerMidline: 'Correct upper + lower midline',
//   correctUpper: 'Correct Upper by 1-5mm',
//   correctLower: 'Correct Lower by 1-5 mm'
// }

const teethGraph = [
    {
        margin: '352px 0px 0px 206px',
        width: 56,
    },
    {
        margin: '305px 0px 0px 211px',
        width: 59,
    },
    {
        margin: '253px 0px 0px 216px',
        width: 61,
    },
    {
        margin: '214px 0px 0px 230px',
        width: 59,
    },
    {
        margin: '178px 0px 0px 247px',
        width: 58,
    },
    {
        margin: '146px 0px 0px 272px',
        width: 48,
    },
    {
        margin: '118px 0px 0px 296px',
        width: 48,
    },
    {
        margin: '108px 0px 0px 328px',
        width: 49,
    },
    {
        margin: '108px 0px 0px 370px',
        deg: 'scaleX(-1)',
        width: 49,
    },
    {
        margin: '118px 0px 0px 402px',
        deg: 'scaleX(-1)',
        width: 48,
    },
    {
        margin: '146px 0px 0px 425px',
        deg: 'scaleX(-1)',
        width: 48,
    },
    {
        margin: '178px 0px 0px 444px',
        deg: 'scaleX(-1)',
        width: 58,
    },
    {
        margin: '214px 0px 0px 460px',
        deg: 'scaleX(-1)',
        width: 59,
    },
    {
        margin: '253px 0px 0px 474px',
        deg: 'scaleX(-1)',
        width: 61,
    },
    {
        margin: '305px 0px 0px 488px',
        deg: 'scaleX(-1)',
        width: 59,
    },
    {
        margin: '352px 0px 0px 497px',
        deg: 'scaleX(-1)',
        width: 56,
    },
    {
        margin: '431px 0px 0px 497px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 56,
    },
    {
        margin: '477px 0px 0px 488px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 59,
    },
    {
        margin: '523px 0px 0px 474px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 61,
    },
    {
        margin: '570px 0px 0px 460px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 59,
    },
    {
        margin: '604px 0px 0px 444px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 58,
    },
    {
        margin: '639px 0px 0px 425px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 48,
    },
    {
        margin: '663px 0px 0px 402px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 48,
    },
    {
        margin: '674px 0px 0px 370px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 49,
    },
    {
        margin: '674px 0px 0px 328px',
        deg: 'scaleY(-1)',
        width: 49,
    },
    {
        margin: '663px 0px 0px 296px',
        deg: 'scaleY(-1)',
        width: 48,
    },
    {
        margin: '639px 0px 0px 272px',
        deg: 'scaleY(-1)',
        width: 48,
    },
    {
        margin: '604px 0px 0px 247px',
        deg: 'scaleY(-1)',
        width: 59,
    },
    {
        margin: '570px 0px 0px 230px',
        deg: 'scaleY(-1)',
        width: 61,
    },
    {
        margin: '523px 0px 0px 216px',
        deg: 'scaleY(-1)',
        width: 61,
    },
    {
        margin: '477px 0px 0px 211px',
        deg: 'scaleY(-1)',
        width: 59,
    },
    {
        margin: '431px 0px 0px 206px',
        deg: 'scaleY(-1)',
        width: 58,
    },
];

class FinishingRetainerSummary extends Component {
    labelIntrerpret = {
        primary: this.get('questionnaire.primary'),
        secondary: this.get('questionnaire.secondary'),
        none: this.get('questionnaire.none'),
        clinicalSimulation: this.get('questionnaire.referToClinicalSimulation'),
        improve1mm: this.get('questionnaire.improve1mm'),
        improve2mm: this.get('questionnaire.improve2mm'),
        improve3mm: this.get('questionnaire.improve3mm'),
        improve4mm: this.get('questionnaire.improve4mm'),
        improve5mm: this.get('questionnaire.improve5mm'),
        maintain: this.get('questionnaire.maintain'),
        improve: this.get('questionnaire.improve'),
        improveUpper: 'Improve Upper to match Facial Midline',
        lowerLower: 'Improve Lower midline to match Upper midline',
        upperLowerMidline: 'Correct upper + lower midline',
        correctUpper: this.get('questionnaire.correctUpper'),
        correctLower: this.get('questionnaire.correctLower'),
    };

    gainingSpaceCheckBox = [
        { name: 'crowding', label: this.get('questionnaire.crowding') },
        { name: 'deepBite', label: this.get('questionnaire.deepBite') },
        { name: 'spacing', label: this.get('questionnaire.spacing') },
        { name: 'classII', label: this.get('questionnaire.classII') },
        { name: 'ClassIIDivI', label: this.get('questionnaire.ClassIIDivI') },
        { name: 'classIII', label: this.get('questionnaire.classIII') },
        { name: 'unevenSmile', label: this.get('questionnaire.unevenSmile') },
        { name: 'openBite', label: this.get('questionnaire.openBite') },
        { name: 'overbite', label: this.get('questionnaire.overbite') },
        { name: 'other', label: this.get('questionnaire.other') },
    ];

    constructor(props) {
        super(props);
        this.state = {
            errors: [],
        };
    }

    // componentDidUpdate()
    // {
    // 	this.props.NewPaitientData.files.map((v,index)=>{
    // 		if(index < 6 && v.data === "" && !v.upload_later)
    // 		{
    // 			errorsList.push('Please Upload All The mandatory Photos')
    // 		}
    // 	})
    // }

    render() {
        let { NewCaseType } = this.props;
        let summaryerrors = fromJS(this.props.NewPaitientData.errors);

        let clinical_condition =
            this.props.NewPaitientData.clinical_cond.length > 0
                ? this.props.NewPaitientData.clinical_cond.split`,`.map((x) => +x)
                : [];
        let { labelIntrerpret } = this;

        let impressionErrorException = this.props.NewPaitientData.files.some(
            (v) =>
                v.category === 'stl_file' &&
                !v.data &&
                !(v.id === 'impression_scan_two' && v.data === null) &&
                !v.upload_later &&
                !v.will_not_upload
        );
        return (
            <Grid container spacing={3}>
                <Grid item xs={12} sm={8}>
                    <div className={style.LeftGrid}>
                        <div className={style.UploadedImages}>
                            {NewCaseType !== 'RETAINER' && (
                                <>
                                    <p>{this.get('@NewPatient.summary.allPhotos')}</p>
                                    <Grid container>
                                        {this.props.NewPaitientData.files.map(
                                            (value, index) =>
                                                value.category == 'photo' &&
                                                [
                                                    'jaw_side_with_smile',
                                                    'face_front_with_smile',
                                                    'teeth_side_without_smile',
                                                    'jaw_front_with_smile',
                                                    'teeth_side_with_smile',
                                                    'jaw_side_without_smile',
                                                ].includes(value.id) && (
                                                    <Grid item xs={4} key={index}>
                                                        {value.uploaded ? (
                                                            <Zoom zoomMargin={48}>
                                                                <img
                                                                    src={`${value.dataURL ?? value.data}`}
                                                                    style={{
                                                                        maxHeight: '300px',
                                                                        width: 'auto',
                                                                        marginLeft: 'auto',
                                                                        marginRight: 'auto',
                                                                        maxWidth: '100%',
                                                                        transform: value.flipped
                                                                            ? `scaleX(-1) rotateZ(${value.rotate}deg)`
                                                                            : `rotateZ(${value.rotate}deg)`,
                                                                    }}
                                                                />
                                                            </Zoom>
                                                        ) : [
                                                              'jaw_side_with_smile',
                                                              'face_front_with_smile',
                                                              'teeth_side_without_smile',
                                                              'jaw_front_with_smile',
                                                              'teeth_side_with_smile',
                                                              'jaw_side_without_smile',
                                                          ].includes(value.id) ? (
                                                            <img
                                                                src={getWebAbsPath('/img/uploadLater.png')}
                                                                style={{
                                                                    maxHeight: '300px',
                                                                    width: 'auto',
                                                                    marginLeft: 'auto',
                                                                    marginRight: 'auto',
                                                                    maxWidth: '100%',
                                                                    transform: value.flipped
                                                                        ? `scaleX(-1) rotateZ(${value.rotate}deg)`
                                                                        : `rotateZ(${value.rotate}deg)`,
                                                                }}
                                                            />
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </Grid>
                                                )
                                        )}
                                    </Grid>
                                </>
                            )}
                            <p>{this.get('summary.allImpressions')}</p>
                            <Grid container>
                                {this.props.NewPaitientData.files
                                    .filter((value) => value.category == 'stl_file')
                                    .map((value, index) => (
                                        <Grid item xs={4} key={index}>
                                            {(value.uploaded &&
                                                this.props.requestFinishingRetainerData
                                                    .request_finishing_retainerOptB === '1') ||
                                            this.props.requestFinishingRetainerData.request_finishing_retainerOptB ===
                                                '0' ? (
                                                <Box>
                                                    <img
                                                        src={`${value.data ? getWebAbsPath('/img/uploaded.png') : getWebAbsPath('/img/imageUpload.png')}`}
                                                        style={{
                                                            maxHeight: '300px',
                                                            width: 'auto',
                                                            marginLeft: 'auto',
                                                            marginRight: 'auto',
                                                            maxWidth: '100%',
                                                            transform: value.flipped
                                                                ? `scaleX(-1) rotateZ(${value.rotate}deg)`
                                                                : `rotateZ(${value.rotate}deg)`,
                                                        }}
                                                    />
                                                    <Typography variant="subtitle1">
                                                        {['Upper STL', 'Lower STL', 'Bite 1 STL', 'Bite 2 STL'][index]}
                                                    </Typography>
                                                </Box>
                                            ) : (
                                                <Box>
                                                    <img
                                                        src={getWebAbsPath('/img/uploadLater.png')}
                                                        style={{
                                                            maxHeight: '300px',
                                                            width: 'auto',
                                                            marginLeft: 'auto',
                                                            marginRight: 'auto',
                                                            maxWidth: '100%',
                                                            transform: value.flipped
                                                                ? `scaleX(-1) rotateZ(${value.rotate}deg)`
                                                                : `rotateZ(${value.rotate}deg)`,
                                                        }}
                                                    />
                                                    <Typography variant="subtitle1">
                                                        {['Upper STL', 'Lower STL', 'Bite 1 STL', 'Bite 2 STL'][index]}
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Grid>
                                    ))}
                            </Grid>
                            <Grid container>
                                <ul className={style.errorList}>
                                    {summaryerrors.toJS().map((v, index) => {
                                        if (
                                            this.props.requestFinishingRetainerData.request_finishing_retainerOptB ===
                                                '0' &&
                                            v.id === 'impression'
                                        )
                                            return;
                                        switch (v.id) {
                                            case 'photo': {
                                                return !v.valid && <li key={index}>{v.msg}</li>;
                                            }
                                            case 'impression': {
                                                return !v.valid && <li key={index}>{v.msg}</li>;
                                            }
                                        }
                                    })}
                                </ul>
                            </Grid>
                        </div>
                    </div>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        NewPaitientData: store.newPatientReducer,
        NewAddressData: store.newAddressReducer,
        requestFinishingRetainerData: store.requestFinishingRetainerReducer.toJS(),
        lang: store.lang,
    };
};

export default connect(mapStateToProps)(withLang(FinishingRetainerSummary, 'FinishingRetainerSummary'));
